import { colors } from '../../colors';
var socialIcon = {
  fillColor: colors.darkSage,
  fillHoverColor: colors.white,
  iconColor: colors.white,
  iconHoverColor: colors.wine,
  iconBorderColor: 'transparent',
  iconBorderHoverColor: 'transparent'
};
export default socialIcon;